const translations: Record<string, { en: string; ar: string }> = {
  // Sidebar
  dashboard: { en: 'Dashboard', ar: 'لوحة التحكم' },
  categories: { en: 'Categories', ar: 'الفئات' },
  products: { en: 'Products', ar: 'المنتجات' },
  orders: { en: 'Orders', ar: 'الطلبات' },
  pos: { en: 'Point of Sale', ar: 'نقطة البيع' },
  design: { en: 'Design', ar: 'التصميم' },
  settings: { en: 'Settings', ar: 'الإعدادات' },
  view_store: { en: 'View Store', ar: 'عرض المتجر' },
  subscription: { en: 'Subscription', ar: 'خطة الاشتراك' },
  logout: { en: 'Logout', ar: 'تسجيل الخروج' },
  hello: { en: 'Hello', ar: 'مرحبا' },

  // Dashboard Home
  todays_orders: { en: "Today's Orders", ar: 'طلبات اليوم' },
  todays_revenue: { en: "Today's Revenue", ar: 'إيرادات اليوم' },
  total_orders: { en: 'Total Orders', ar: 'إجمالي الطلبات' },
  total_revenue: { en: 'Total Revenue', ar: 'إجمالي الإيرادات' },
  total_products: { en: 'Products', ar: 'المنتجات' },
  total_categories: { en: 'Categories', ar: 'الفئات' },
  pending_orders: { en: 'Pending Orders', ar: 'طلبات معلقة' },
  recent_orders: { en: 'Recent Orders', ar: 'آخر الطلبات' },
  loading: { en: 'Loading...', ar: 'جاري التحميل...' },
  order: { en: 'Order', ar: 'الطلب' },
  customer: { en: 'Customer', ar: 'العميل' },
  total: { en: 'Total', ar: 'المجموع' },
  status: { en: 'Status', ar: 'الحالة' },
  date: { en: 'Date', ar: 'التاريخ' },

  // Categories
  add_category: { en: 'Add Category', ar: 'إضافة فئة' },
  edit_category: { en: 'Edit Category', ar: 'تعديل الفئة' },
  no_categories: { en: 'No categories yet', ar: 'لا توجد فئات بعد' },
  add_first_category: { en: 'Add your first category to organize products', ar: 'أضف أول فئة لتنظيم المنتجات' },
  name_en: { en: 'Name (English)', ar: 'الاسم (إنجليزي)' },
  name_ar: { en: 'Name (Arabic)', ar: 'الاسم (عربي)' },
  description: { en: 'Description', ar: 'الوصف' },
  sort_order: { en: 'Sort Order', ar: 'ترتيب العرض' },
  image: { en: 'Image', ar: 'الصورة' },
  cancel: { en: 'Cancel', ar: 'إلغاء' },
  create: { en: 'Create', ar: 'إنشاء' },
  update: { en: 'Update', ar: 'تحديث' },
  name: { en: 'Name', ar: 'الاسم' },
  actions: { en: 'Actions', ar: 'الإجراءات' },
  category_created: { en: 'Category created', ar: 'تم إنشاء الفئة' },
  category_updated: { en: 'Category updated', ar: 'تم تحديث الفئة' },
  category_deleted: { en: 'Category deleted', ar: 'تم حذف الفئة' },
  error_saving_category: { en: 'Error saving category', ar: 'خطأ في حفظ الفئة' },
  error_deleting_category: { en: 'Error deleting category', ar: 'خطأ في حذف الفئة' },
  delete_category_confirm: { en: 'Delete this category?', ar: 'هل تريد حذف هذه الفئة؟' },

  // Products
  add_product: { en: 'Add Product', ar: 'إضافة منتج' },
  edit_product: { en: 'Edit Product', ar: 'تعديل المنتج' },
  no_products: { en: 'No products yet', ar: 'لا توجد منتجات بعد' },
  add_first_product: { en: 'Add your first product to start selling', ar: 'أضف أول منتج لبدء البيع' },
  category: { en: 'Category', ar: 'الفئة' },
  select_category: { en: 'Select category', ar: 'اختر الفئة' },
  desc_en: { en: 'Description (English)', ar: 'الوصف (إنجليزي)' },
  desc_ar: { en: 'Description (Arabic)', ar: 'الوصف (عربي)' },
  price: { en: 'Price', ar: 'السعر' },
  compare_price: { en: 'Compare Price', ar: 'سعر المقارنة' },
  calories: { en: 'Calories', ar: 'السعرات' },
  prep_time: { en: 'Prep Time', ar: 'وقت التحضير' },
  active: { en: 'Active', ar: 'نشط' },
  inactive: { en: 'Inactive', ar: 'غير نشط' },
  featured: { en: 'Featured', ar: 'مميز' },
  product_created: { en: 'Product created', ar: 'تم إنشاء المنتج' },
  product_updated: { en: 'Product updated', ar: 'تم تحديث المنتج' },
  product_deleted: { en: 'Product deleted', ar: 'تم حذف المنتج' },
  error_saving_product: { en: 'Error saving product', ar: 'خطأ في حفظ المنتج' },
  error_deleting_product: { en: 'Error deleting product', ar: 'خطأ في حذف المنتج' },
  delete_product_confirm: { en: 'Delete this product?', ar: 'هل تريد حذف هذا المنتج؟' },

  // Orders
  all_orders: { en: 'All Orders', ar: 'كل الطلبات' },
  no_orders: { en: 'No orders yet', ar: 'لا توجد طلبات بعد' },
  orders_appear_here: { en: 'Orders will appear here when customers place them', ar: 'ستظهر الطلبات هنا عندما يقوم العملاء بتقديمها' },
  order_number: { en: 'Order #', ar: 'رقم الطلب' },
  phone: { en: 'Phone', ar: 'الهاتف' },
  type: { en: 'Type', ar: 'النوع' },
  view: { en: 'View', ar: 'عرض' },
  close: { en: 'Close', ar: 'إغلاق' },
  address: { en: 'Address', ar: 'العنوان' },
  notes: { en: 'Notes', ar: 'ملاحظات' },
  item: { en: 'Item', ar: 'المنتج' },
  qty: { en: 'Qty', ar: 'الكمية' },
  subtotal: { en: 'Subtotal', ar: 'المجموع الفرعي' },
  delivery: { en: 'Delivery', ar: 'التوصيل' },
  order_status_updated: { en: 'Order status updated', ar: 'تم تحديث حالة الطلب' },
  error_updating_status: { en: 'Error updating status', ar: 'خطأ في تحديث الحالة' },
  create_order: { en: 'Create Order', ar: 'إنشاء طلب' },
  add_item: { en: 'Add Item', ar: 'إضافة منتج' },
  select_product: { en: 'Select Product', ar: 'اختر المنتج' },
  quantity: { en: 'Quantity', ar: 'الكمية' },
  payment_link: { en: 'Payment Link', ar: 'رابط الدفع' },
  copy_link: { en: 'Copy Link', ar: 'نسخ الرابط' },
  link_copied: { en: 'Link copied!', ar: 'تم نسخ الرابط!' },
  order_created: { en: 'Order created', ar: 'تم إنشاء الطلب' },
  error_creating_order: { en: 'Error creating order', ar: 'خطأ في إنشاء الطلب' },
  remove: { en: 'Remove', ar: 'حذف' },
  payment_status: { en: 'Payment', ar: 'الدفع' },
  paid: { en: 'Paid', ar: 'مدفوع' },
  unpaid: { en: 'Unpaid', ar: 'غير مدفوع' },
  search_products: { en: 'Search products...', ar: 'البحث عن منتجات...' },
  no_more_orders: { en: 'No more orders', ar: 'لا توجد طلبات أخرى' },
  load_more: { en: 'Load More', ar: 'تحميل المزيد' },
  deliveries: { en: 'Deliveries', ar: 'التوصيل' },
  dispatch: { en: 'Dispatch', ar: 'إرسال' },
  assign_driver: { en: 'Assign Driver', ar: 'تعيين سائق' },
  driver: { en: 'Driver', ar: 'السائق' },
  select_driver: { en: 'Select driver', ar: 'اختر سائق' },
  dispatched: { en: 'Dispatched', ar: 'تم الإرسال' },
  not_dispatched: { en: 'Not dispatched', ar: 'لم يتم الإرسال' },
  dispatch_success: { en: 'Order dispatched to driver', ar: 'تم إرسال الطلب للسائق' },
  print_delivery_list: { en: 'Print Delivery List', ar: 'طباعة قائمة التوصيل' },
  delivery_slip: { en: 'Delivery Slip', ar: 'إيصال التوصيل' },
  no_deliveries: { en: 'No delivery orders yet', ar: 'لا توجد طلبات توصيل بعد' },
  all_deliveries: { en: 'All', ar: 'الكل' },
  my_deliveries: { en: 'My Deliveries', ar: 'توصيلاتي' },
  unassigned: { en: 'Unassigned', ar: 'غير معين' },

  // Status names
  pending: { en: 'pending', ar: 'معلق' },
  confirmed: { en: 'confirmed', ar: 'مؤكد' },
  preparing: { en: 'preparing', ar: 'قيد التحضير' },
  ready: { en: 'ready', ar: 'جاهز' },
  out_for_delivery: { en: 'out for delivery', ar: 'في الطريق' },
  delivered: { en: 'delivered', ar: 'تم التوصيل' },
  cancelled: { en: 'cancelled', ar: 'ملغي' },

  // Store Settings
  store_settings: { en: 'Store Settings', ar: 'إعدادات المتجر' },
  save_changes: { en: 'Save Changes', ar: 'حفظ التغييرات' },
  saving: { en: 'Saving...', ar: 'جاري الحفظ...' },
  settings_saved: { en: 'Settings saved', ar: 'تم حفظ الإعدادات' },
  error_saving: { en: 'Error saving', ar: 'خطأ في الحفظ' },
  general_info: { en: 'General Info', ar: 'معلومات عامة' },
  store_name: { en: 'Store Name', ar: 'اسم المتجر' },
  announcement_banner: { en: 'Announcement Banner', ar: 'شريط الإعلانات' },
  announcement_placeholder: { en: 'e.g. Free delivery on orders above 5 KD!', ar: 'مثال: توصيل مجاني للطلبات فوق 5 د.ك!' },
  store_is_open: { en: 'Store is Open', ar: 'المتجر مفتوح' },
  branding: { en: 'Branding', ar: 'العلامة التجارية' },
  logo: { en: 'Logo', ar: 'الشعار' },
  cover_image: { en: 'Cover Image', ar: 'صورة الغلاف' },
  contact_info: { en: 'Contact Info', ar: 'معلومات التواصل' },
  email: { en: 'Email', ar: 'البريد الإلكتروني' },
  whatsapp: { en: 'WhatsApp', ar: 'واتساب' },
  city: { en: 'City', ar: 'المدينة' },
  country: { en: 'Country', ar: 'الدولة' },
  social_media: { en: 'Social Media', ar: 'وسائل التواصل' },
  delivery_pickup: { en: 'Delivery & Pickup', ar: 'التوصيل والاستلام' },
  delivery_enabled: { en: 'Delivery Enabled', ar: 'التوصيل متاح' },
  pickup_enabled: { en: 'Pickup Enabled', ar: 'الاستلام متاح' },
  delivery_fee: { en: 'Delivery Fee', ar: 'رسوم التوصيل' },
  minimum_order: { en: 'Minimum Order', ar: 'الحد الأدنى للطلب' },
  est_delivery_time: { en: 'Estimated Delivery Time (min)', ar: 'وقت التوصيل المقدر (دقيقة)' },
  min: { en: 'min', ar: 'دقيقة' },
  currency_seo: { en: 'Currency & SEO', ar: 'العملة وتحسين محركات البحث' },
  currency_code: { en: 'Currency Code', ar: 'رمز العملة' },
  currency_symbol: { en: 'Currency Symbol', ar: 'رمز العملة' },
  meta_title: { en: 'Meta Title', ar: 'عنوان الميتا' },
  meta_description: { en: 'Meta Description', ar: 'وصف الميتا' },
  logo_updated: { en: 'Logo updated', ar: 'تم تحديث الشعار' },
  error_uploading_logo: { en: 'Error uploading logo', ar: 'خطأ في رفع الشعار' },
  cover_updated: { en: 'Cover image updated', ar: 'تم تحديث صورة الغلاف' },
  error_uploading_cover: { en: 'Error uploading cover', ar: 'خطأ في رفع الغلاف' },
  file_too_large: { en: 'File is too large. Maximum size is {size}', ar: 'الملف كبير جداً. الحد الأقصى {size}' },

  // Design Settings
  design_layout: { en: 'Design & Layout', ar: 'التصميم والتخطيط' },
  store_layout: { en: 'Store Layout', ar: 'تخطيط المتجر' },
  colors: { en: 'Colors', ar: 'الألوان' },
  primary_color: { en: 'Primary Color', ar: 'اللون الرئيسي' },
  secondary_color: { en: 'Secondary Color', ar: 'اللون الثانوي' },
  accent_color: { en: 'Accent Color', ar: 'لون التمييز' },
  text_color: { en: 'Text Color', ar: 'لون النص' },
  background_color: { en: 'Background Color', ar: 'لون الخلفية' },
  typography: { en: 'Typography', ar: 'الخطوط' },
  font_family: { en: 'Font Family', ar: 'نوع الخط' },
  preview_text: { en: 'Preview Text', ar: 'نص المعاينة' },
  preview_sentence: { en: 'The quick brown fox jumps over the lazy dog', ar: 'نص تجريبي لمعاينة الخط المختار' },
  section_visibility: { en: 'Section Visibility', ar: 'إظهار الأقسام' },
  header_banner: { en: 'Header Banner', ar: 'شعار الرأس' },
  categories_bar: { en: 'Categories Bar', ar: 'شريط الفئات' },
  search_bar: { en: 'Search Bar', ar: 'شريط البحث' },
  featured_products: { en: 'Featured Products', ar: 'المنتجات المميزة' },
  store_info_section: { en: 'Store Info Section', ar: 'قسم معلومات المتجر' },
  social_links: { en: 'Social Media Links', ar: 'روابط التواصل' },
  delivery_info: { en: 'Delivery Info', ar: 'معلومات التوصيل' },
  working_hours: { en: 'Working Hours', ar: 'ساعات العمل' },
  theme_editor: { en: 'Theme Editor', ar: 'محرر المظهر' },
  sticky_nav: { en: 'Sticky Navigation Bar', ar: 'شريط التنقل الثابت' },
  sticky_filters: { en: 'Sticky Filters on Scroll', ar: 'تثبيت الفلاتر عند التمرير' },
  infinite_scroll: { en: 'Infinite Scroll (auto-load products)', ar: 'تحميل تلقائي عند التمرير' },
  font_sizes: { en: 'Font Sizes', ar: 'أحجام الخط' },
  font_size_title: { en: 'Store Title', ar: 'عنوان المتجر' },
  font_size_menu: { en: 'Menu / Categories', ar: 'القائمة / الفئات' },
  font_size_product_name: { en: 'Product Name', ar: 'اسم المنتج' },
  font_size_product_price: { en: 'Product Price', ar: 'سعر المنتج' },
  font_size_body: { en: 'Body Text', ar: 'النص العام' },
  design_saved: { en: 'Design settings saved', ar: 'تم حفظ إعدادات التصميم' },

  // Promo Codes
  promo_codes: { en: 'Promo Codes', ar: 'أكواد الخصم' },
  add_promo: { en: 'Add Promo Code', ar: 'إضافة كود خصم' },
  edit_promo: { en: 'Edit Promo Code', ar: 'تعديل كود الخصم' },
  no_promos: { en: 'No promo codes yet', ar: 'لا توجد أكواد خصم بعد' },
  add_first_promo: { en: 'Create your first promo code to offer discounts', ar: 'أنشئ أول كود خصم لتقديم عروض' },
  code: { en: 'Code', ar: 'الكود' },
  discount_type: { en: 'Discount Type', ar: 'نوع الخصم' },
  percentage: { en: 'Percentage', ar: 'نسبة مئوية' },
  fixed_amount: { en: 'Fixed Amount', ar: 'مبلغ ثابت' },
  discount_value: { en: 'Discount Value', ar: 'قيمة الخصم' },
  min_order_amount: { en: 'Min Order Amount', ar: 'الحد الأدنى للطلب' },
  max_discount: { en: 'Max Discount', ar: 'أقصى خصم' },
  start_date: { en: 'Start Date', ar: 'تاريخ البداية' },
  end_date: { en: 'End Date', ar: 'تاريخ الانتهاء' },
  usage_limit: { en: 'Usage Limit', ar: 'حد الاستخدام' },
  usage: { en: 'Usage', ar: 'الاستخدام' },
  unlimited: { en: 'Unlimited', ar: 'غير محدود' },
  specific_products: { en: 'Specific Products', ar: 'منتجات محددة' },
  specific_categories: { en: 'Specific Categories', ar: 'فئات محددة' },
  all_items: { en: 'All Items', ar: 'جميع المنتجات' },
  show_on_store: { en: 'Show on Store', ar: 'عرض في المتجر' },
  expired: { en: 'Expired', ar: 'منتهي' },
  depleted: { en: 'Depleted', ar: 'مستنفد' },
  promo_created: { en: 'Promo code created', ar: 'تم إنشاء كود الخصم' },
  promo_updated: { en: 'Promo code updated', ar: 'تم تحديث كود الخصم' },
  promo_deleted: { en: 'Promo code deleted', ar: 'تم حذف كود الخصم' },
  error_saving_promo: { en: 'Error saving promo code', ar: 'خطأ في حفظ كود الخصم' },
  error_deleting_promo: { en: 'Error deleting promo code', ar: 'خطأ في حذف كود الخصم' },
  delete_promo_confirm: { en: 'Delete this promo code?', ar: 'هل تريد حذف كود الخصم؟' },
  apply: { en: 'Apply', ar: 'تطبيق' },
  discount_label: { en: 'Discount', ar: 'الخصم' },
  visible: { en: 'Visible', ar: 'مرئي' },
  hidden: { en: 'Hidden', ar: 'مخفي' },

  // Layout names
  modern: { en: 'Modern', ar: 'عصري' },
  classic: { en: 'Classic', ar: 'كلاسيكي' },
  minimal: { en: 'Minimal', ar: 'بسيط' },
  elegant: { en: 'Elegant', ar: 'أنيق' },
  modern_desc: { en: 'Clean and contemporary with bold accents', ar: 'تصميم نظيف وعصري بلمسات جريئة' },
  classic_desc: { en: 'Traditional layout with sidebar navigation', ar: 'تخطيط تقليدي مع قائمة جانبية' },
  minimal_desc: { en: 'Simple and elegant with focus on products', ar: 'بسيط وأنيق مع التركيز على المنتجات' },
  elegant_desc: { en: 'Premium look with dark header and rich typography', ar: 'مظهر فاخر مع رأس داكن وخطوط غنية' },
  food: { en: 'Food', ar: 'مطاعم' },
  food_desc: { en: 'Split layout with banner left, menu right — ideal for restaurants', ar: 'تصميم مقسم بصورة يسار وقائمة يمين — مثالي للمطاعم' },
  advanced: { en: 'Advanced', ar: 'متقدم' },
  advanced_desc: { en: 'Full e-commerce with filters, variants, attributes — ideal for retail', ar: 'متجر متكامل مع فلاتر ومتغيرات وخصائص — مثالي للبيع بالتجزئة' },
  boutique: { en: 'Boutique', ar: 'بوتيك' },
  boutique_desc: { en: 'Monochrome fashion look with tall imagery — ideal for abayas and clothing', ar: 'مظهر أزياء أحادي اللون بصور طولية — مثالي للعبايات والملابس' },

  // Delivery Areas
  delivery_areas: { en: 'Delivery Areas', ar: 'مناطق التوصيل' },
  add_area: { en: 'Add Area', ar: 'إضافة منطقة' },
  edit_area: { en: 'Edit Area', ar: 'تعديل المنطقة' },
  area_name: { en: 'Area Name (Arabic)', ar: 'اسم المنطقة (عربي)' },
  area_name_en: { en: 'Area Name (English)', ar: 'اسم المنطقة (إنجليزي)' },
  no_areas: { en: 'No delivery areas yet', ar: 'لا توجد مناطق توصيل بعد' },
  add_first_area: { en: 'Add your first delivery area or load default Kuwait areas', ar: 'أضف أول منطقة توصيل أو حمّل مناطق الكويت الافتراضية' },
  load_kuwait_areas: { en: 'Load Kuwait Areas', ar: 'تحميل مناطق الكويت' },
  load_kuwait_confirm: { en: 'Load default Kuwait delivery areas? This will add all Kuwait areas.', ar: 'تحميل مناطق التوصيل الافتراضية للكويت؟ سيتم إضافة جميع مناطق الكويت.' },
  areas_loaded: { en: 'Kuwait areas loaded successfully', ar: 'تم تحميل مناطق الكويت بنجاح' },
  area_created: { en: 'Area created', ar: 'تم إنشاء المنطقة' },
  area_updated: { en: 'Area updated', ar: 'تم تحديث المنطقة' },
  area_deleted: { en: 'Area deleted', ar: 'تم حذف المنطقة' },
  error_saving_area: { en: 'Error saving area', ar: 'خطأ في حفظ المنطقة' },
  error_deleting_area: { en: 'Error deleting area', ar: 'خطأ في حذف المنطقة' },
  search_areas: { en: 'Search areas...', ar: 'البحث عن مناطق...' },
  enable_selected: { en: 'Enable Selected', ar: 'تفعيل المحدد' },
  disable_selected: { en: 'Disable Selected', ar: 'تعطيل المحدد' },
  select_area: { en: 'Select Area', ar: 'اختر المنطقة' },
  available_in_areas: { en: 'Available in Areas', ar: 'متوفر في المناطق' },
  all_areas_default: { en: 'Leave empty for all areas', ar: 'اتركه فارغاً لجميع المناطق' },
  select_all: { en: 'Select All', ar: 'تحديد الكل' },
  deselect_all: { en: 'Deselect All', ar: 'إلغاء تحديد الكل' },

  // Branches
  branches: { en: 'Branches', ar: 'الفروع' },
  add_branch: { en: 'Add Branch', ar: 'إضافة فرع' },
  edit_branch: { en: 'Edit Branch', ar: 'تعديل الفرع' },
  no_branches: { en: 'No branches yet', ar: 'لا توجد فروع بعد' },
  add_first_branch: { en: 'Add your first branch for pickup orders', ar: 'أضف أول فرع لطلبات الاستلام' },
  branch_name_en: { en: 'Branch Name (English)', ar: 'اسم الفرع (إنجليزي)' },
  branch_name_ar: { en: 'Branch Name (Arabic)', ar: 'اسم الفرع (عربي)' },
  branch_created: { en: 'Branch created', ar: 'تم إنشاء الفرع' },
  branch_updated: { en: 'Branch updated', ar: 'تم تحديث الفرع' },
  branch_deleted: { en: 'Branch deleted', ar: 'تم حذف الفرع' },
  error_saving_branch: { en: 'Error saving branch', ar: 'خطأ في حفظ الفرع' },
  error_deleting_branch: { en: 'Error deleting branch', ar: 'خطأ في حذف الفرع' },
  delete_branch_confirm: { en: 'Delete this branch?', ar: 'هل تريد حذف هذا الفرع؟' },
  working_hours_from: { en: 'Opens at', ar: 'يفتح الساعة' },
  working_hours_to: { en: 'Closes at', ar: 'يغلق الساعة' },
  google_maps_url: { en: 'Google Maps Link', ar: 'رابط خرائط جوجل' },
  stock: { en: 'Stock', ar: 'المخزون' },
  stock_updated: { en: 'Stock updated', ar: 'تم تحديث المخزون' },
  available: { en: 'Available', ar: 'متاح' },

  // Product Advanced Fields
  sku: { en: 'SKU', ar: 'رمز المنتج' },
  model_number: { en: 'Model', ar: 'الموديل' },
  stock_management: { en: 'Stock', ar: 'المخزون' },
  track_stock: { en: 'Track Stock', ar: 'تتبع المخزون' },
  subtract_stock: { en: 'Subtract Stock on Order', ar: 'خصم المخزون عند الطلب' },
  date_available: { en: 'Date Available', ar: 'تاريخ التوفر' },
  requires_delivery: { en: 'Requires Delivery', ar: 'يتطلب توصيل' },
  requires_delivery_hint: { en: 'Cannot be picked up', ar: 'لا يمكن استلامه' },
  seo_settings: { en: 'SEO', ar: 'تحسين محركات البحث' },
  meta_keywords: { en: 'Meta Keywords', ar: 'كلمات الميتا' },
  tags: { en: 'Tags', ar: 'الوسوم' },
  add_tag: { en: 'Add tag...', ar: 'أضف وسم...' },
  attributes: { en: 'Attributes', ar: 'الخصائص' },
  add_attribute: { en: 'Add Attribute', ar: 'إضافة خاصية' },
  attribute_key: { en: 'Name', ar: 'الاسم' },
  attribute_value: { en: 'Value', ar: 'القيمة' },
  options_label: { en: 'Options', ar: 'الخيارات' },
  add_option: { en: 'Add Option', ar: 'إضافة خيار' },
  option_name: { en: 'Option Name', ar: 'اسم الخيار' },
  option_values: { en: 'Values (comma separated)', ar: 'القيم (مفصولة بفاصلة)' },
  option_price: { en: 'Extra Price', ar: 'سعر إضافي' },
  additional_images: { en: 'Additional Images', ar: 'صور إضافية' },
  product_details: { en: 'Details', ar: 'التفاصيل' },

  // Payment Gateways
  payment_gateways: { en: 'Payment Gateways', ar: 'بوابات الدفع' },

  // Team
  customers: { en: 'Customers', ar: 'العملاء' },
  api_access: { en: 'API Access', ar: 'الوصول للـ API' },
  team: { en: 'Team', ar: 'المستخدمين' },
  roles: { en: 'Roles', ar: 'المسميات الوظيفية' },
  users: { en: 'Users', ar: 'المستخدمين' },
  add_role: { en: 'Add Role', ar: 'إضافة مسمى وظيفي' },
  edit_role: { en: 'Edit Role', ar: 'تعديل المسمى الوظيفي' },
  edit_user: { en: 'Edit User', ar: 'تعديل المستخدم' },
  add_user: { en: 'Add User', ar: 'إضافة مستخدم' },
  role_name: { en: 'Role Name', ar: 'اسم المسمى الوظيفي' },
  permissions: { en: 'Permissions', ar: 'الصلاحيات' },
  no_roles: { en: 'No roles yet', ar: 'لا توجد مسميات وظيفية بعد' },
  no_users: { en: 'No team members yet', ar: 'لا يوجد أعضاء فريق بعد' },
  create_first_role: { en: 'Create a role first to define permissions', ar: 'أنشئ مسمى وظيفي أولاً لتحديد الصلاحيات' },
  add_first_user: { en: 'Add team members to help manage your store', ar: 'أضف أعضاء فريق للمساعدة في إدارة متجرك' },
  role_created: { en: 'Role created', ar: 'تم إنشاء المسمى الوظيفي' },
  role_updated: { en: 'Role updated', ar: 'تم تحديث المسمى الوظيفي' },
  role_deleted: { en: 'Role deleted', ar: 'تم حذف المسمى الوظيفي' },
  user_added: { en: 'User added to team', ar: 'تمت إضافة المستخدم للفريق' },
  user_updated: { en: 'User updated', ar: 'تم تحديث المستخدم' },
  user_removed: { en: 'User removed from team', ar: 'تمت إزالة المستخدم من الفريق' },
  first_name: { en: 'First Name', ar: 'الاسم الأول' },
  last_name: { en: 'Last Name', ar: 'الاسم الأخير' },
  password: { en: 'Password', ar: 'كلمة المرور' },
  role: { en: 'Role', ar: 'المسمى الوظيفي' },
  select_role: { en: 'Select role', ar: 'اختر المسمى الوظيفي' },
  no_role: { en: 'No role', ar: 'بدون مسمى' },
  owner: { en: 'Owner', ar: 'المالك' },
  delete_role_confirm: { en: 'Delete this role? Users with this role will lose their permissions.', ar: 'حذف هذا المسمى الوظيفي؟ سيفقد المستخدمون صلاحياتهم.' },
  delete_user_confirm: { en: 'Remove this user from the team?', ar: 'إزالة هذا المستخدم من الفريق؟' },
  resource_dashboard: { en: 'Dashboard', ar: 'لوحة التحكم' },
  resource_categories: { en: 'Categories', ar: 'الفئات' },
  resource_products: { en: 'Products', ar: 'المنتجات' },
  resource_orders: { en: 'Orders', ar: 'الطلبات' },
  resource_pos: { en: 'Point of Sale', ar: 'نقطة البيع' },
  resource_deliveries: { en: 'Deliveries', ar: 'التوصيل' },
  resource_branches: { en: 'Branches', ar: 'الفروع' },
  resource_delivery_areas: { en: 'Delivery Areas', ar: 'مناطق التوصيل' },
  resource_promo_codes: { en: 'Promo Codes', ar: 'أكواد الخصم' },
  resource_customers: { en: 'Customers', ar: 'العملاء' },
  resource_payment_gateways: { en: 'Payment Gateways', ar: 'بوابات الدفع' },
  resource_design: { en: 'Design', ar: 'التصميم' },
  resource_settings: { en: 'Settings', ar: 'الإعدادات' },
  resource_team: { en: 'Team', ar: 'المستخدمين' },
  resource_api_access: { en: 'API Access', ar: 'الوصول للـ API' },
  resource_subscription: { en: 'Subscription', ar: 'الاشتراك' },
  resource_notifications: { en: 'Notifications', ar: 'الإشعارات' },
  perm_sell: { en: 'Sell', ar: 'بيع' },
  perm_cancel: { en: 'Cancel', ar: 'إلغاء' },
  perm_refund: { en: 'Refund', ar: 'استرجاع' },
  perm_manage_stock: { en: 'Stock', ar: 'المخزون' },
  perm_view: { en: 'View All', ar: 'عرض الكل' },
  perm_view_own: { en: 'View Own', ar: 'عرض الخاص' },
  perm_create: { en: 'Create', ar: 'إنشاء' },
  perm_edit: { en: 'Edit', ar: 'تعديل' },
  perm_delete: { en: 'Delete', ar: 'حذف' },
  perm_orders: { en: 'Orders', ar: 'الطلبات' },
  members: { en: 'members', ar: 'أعضاء' },
};

export type DashLang = 'en' | 'ar';

export function dt(key: string, lang: DashLang): string {
  return translations[key]?.[lang] || translations[key]?.en || key;
}

export function getDashLang(): DashLang {
  const saved = localStorage.getItem('cartz_dash_lang');
  return saved === 'ar' ? 'ar' : 'en';
}

export function setDashLang(lang: DashLang) {
  localStorage.setItem('cartz_dash_lang', lang);
}
